import React from 'react'

import { PartnerAccountDataActionsProvider } from './PartnerAccountDataActionsContext'
import {
  PartnerAccountDataProvider,
  type PartnerAccountDataProviderProps,
} from './PartnerAccountDataProvider'
import type { PartnerAccountDataActions } from './types'

export const createPartnerAccountDataProvider = (
  actions: PartnerAccountDataActions
): React.FC<Omit<PartnerAccountDataProviderProps, 'actions'>> => {
  const ConnectedPartnerAccountDataProvider: React.FC<
    Omit<PartnerAccountDataProviderProps, 'actions'>
  > = props => (
    <PartnerAccountDataActionsProvider actions={actions}>
      <PartnerAccountDataProvider {...props} />
    </PartnerAccountDataActionsProvider>
  )

  ConnectedPartnerAccountDataProvider.displayName =
    'ConnectedPartnerAccountDataProvider'

  return ConnectedPartnerAccountDataProvider
}
